import React, { useEffect } from "react"; // import useState hook from react
import TextDisplay from "./components/atoms/title"; // import text display component
import MultiStepForm from "./components/molecules/multistep-form"; // import multi step form component
import "./styles/global.css"; // import global css
import { AwsRum } from "aws-rum-web";
import { initReplay } from "./sessionReplay";
import { Spinner } from "@jobtarget/ui-library";

let awsRum = null;
try {
  const appMonitorId = process.env.REACT_APP_RUM_APP_MONITOR_ID;
  const identityPoolId = process.env.REACT_APP_RUM_IDENTITY_POOL_ID;
  if (appMonitorId && identityPoolId) {
    awsRum = new AwsRum(
      appMonitorId,
      // The release, not a literal: '1.0.0' says nothing about which deploy is live.
      process.env.REACT_APP_APP_RELEASE || '',
      'us-east-1',
      {
        sessionSampleRate: 1,
        identityPoolId,
        endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
        // No 'replay' telemetry: session replay is @jobtarget/browser-rum's job,
        // and two DOM recorders in one document both patch fetch, XHR and console.
        telemetries: [
          'performance',
          'errors',
          [
            'http',
            {
              // Without this a request is recorded but linked to nothing on the
              // backend, so the RUM console's Traces column stays empty.
              addXRayTraceIdHeader: true,
              recordAllRequests: true,
              // aws-rum-web matches the URL as the caller wrote it, so an
              // absolute-only pattern traces nothing for relative fetches.
              urlsToInclude: [/^\/(?!\/)/, /^https?:\/\/[^/?#]*\.jobtarget\.com([/:?#]|$)/],
              // The replay intake is a *.jobtarget.com host, so the include pattern
              // catches it: RUM would instrument the recorder's own uploads, one
              // billable event and one X-Ray segment per chunk.
              urlsToExclude: [/rum-replay-intake\.jobtarget\.com/],
            },
          ],
        ],
        allowCookies: true,
        enableXRay: true,
      },
    );
    // Join the two: the replay SDK pins its session id onto the RUM session, so
    // the console's CloudWatch RUM deep links resolve.
    import('@jobtarget/browser-rum').then(({ registerCloudWatchRum }) =>
      registerCloudWatchRum(awsRum),
    );
  }
} catch (error) {
  // Ignore RUM initialization errors
}

// Session replay. Started at module scope beside the RUM client: the recorder
// wraps fetch, XHR and console as it starts, so anything above it is a blind spot.
initReplay();

function App() {
  const [jwtToken, setJwtToken] = React.useState(null);

  // Effect to set jwtToken from URL
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const jwtTokenParam = urlParams.get("jwtToken");
    if (jwtTokenParam) {
      setJwtToken(jwtTokenParam);
    }
  }, []);


  useEffect(() => {
    console.log("ciw-workbook v1.0.19")
  }, []);


  return (
    <>
      <div className="row mt-2">
        <div className="col-12">
          <TextDisplay text="Online Implementation Workbook" />
        </div>
      </div>{
        jwtToken ? <MultiStepForm jwtToken={jwtToken} /> : <Spinner />
      }
    </>
  );
}

export default App;
